/* You Fly LA kit (yk-) v66 :: yk-enh.js :: built from kit/src */
/* --- 40-enh-a-core.js --- */
/* YFLA kit, enh group (KB4): shared helpers for the copy enhancers (faq, steps, tables, stats) and the
   elements yk-scrubber / yk-compare / yk-gauges / yk-faq. Each 40-enh-*.js file is self-contained and
   guarded by a flag on window.YK_enh, so assets/yk-enh.js can be printed twice on a page.
   Enhancer rules: act only inside a [data-yk-enhance] box; skip existing components (SKIP); never remove
   or rewrite text (nodes are moved or wrapped, never re-typed); idempotent (data-yk-e marks converted
   parts); added UI carries data-yk-ui; classes are yk-e-*, styled only under [data-yk-enhance]. */
(function () {
  'use strict';
  if (window.YK_enh || !window.YK) return;
  var E = window.YK_enh = { v: '1.0' };
  E.SKIP = '[data-yk],.yk,.yh,form,script,style,noscript,template,iframe,object,embed,video,audio,canvas,svg,' +
    'dialog,details,summary,button,select,textarea,input,label,[contenteditable],[data-yfla-mod],[data-ym-ready],' +
    '.yfla,.yfm,.yfcalc,[data-yk-ui]';
  /* the whole box is off limits when it sits inside a component or a form */
  E.bail = function (box) { return !box || !box.closest || !!box.closest('.yh,[data-yk],form'); };
  /* true when el, or an ancestor of it below box, is a zone the enhancers must not touch */
  E.skip = function (el, box) {
    for (var n = el; n && n !== box; n = n.parentElement) {
      if (n.matches(E.SKIP)) return true;
    }
    return n !== box;
  };
  E.text = function (n) { return String((n && n.textContent) || '').replace(/\s+/g, ' ').trim(); };
  E.blank = function (n) { return n.nodeType === 8 || (n.nodeType === 3 && !/\S/.test(n.data)); };
  E.el = function (tag, cls, attrs, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
    if (txt != null) e.textContent = txt;
    return e;
  };
  E.ui = function (e) { e.setAttribute('data-yk-ui', ''); return e; };
  E.has = function (box, name) { return (' ' + (box.getAttribute('data-yk-enhance') || '').replace(/,/g, ' ') + ' ').indexOf(' ' + name + ' ') >= 0; };
  /* a paragraph that holds nothing but buttons (a CTA row), e.g. <p><a class="btn">..</a> <a class="btn">..</a></p> */
  E.btnOnly = function (p) {
    if (p.tagName !== 'P') return false;
    var bs = p.querySelectorAll('a.btn,a[class*="btn"],a.yk-btn,button');
    if (!bs.length) return false;
    var t = E.text(p);
    [].forEach.call(bs, function (b) { t = t.split(E.text(b)).join(''); });
    return !/\w/.test(t);
  };
  /* closed panels: hidden="until-found" where supported (find-in-page still finds the text), else [hidden] */
  E.untilFound = function () { return 'onbeforematch' in document.body; };
  E.hide = function (panel, hide) {
    if (!hide) { panel.removeAttribute('hidden'); return; }
    if (E.untilFound()) panel.setAttribute('hidden', 'until-found'); else panel.hidden = true;
  };
  E.chev = function (dir) {
    var d = dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7';
    return '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="' + d +
      '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  };
  /* Figures: money, hours, percent, months (the stats enhancer's mono spans) and the lead figure of a
     "number + label" line (readout strips). Ranges ("60 to 75 hours", "$1,300–$1,500") stay one figure. */
  var N = '(?:\\d{1,3}(?:,\\d{3})+|\\d+)(?:\\.\\d+)?';
  var DASH = '\\s?(?:\\u2013|\\u2014|-|to)\\s?';
  var R = N + '(?:' + DASH + N + ')?';
  var MON = '\\$' + N + '(?:\\s?(?:K|M|million|billion)\\b)?\\+?(?:' + DASH + '\\$?' + N + '(?:\\s?(?:K|M|million|billion)\\b)?\\+?)?' +
    '(?:\\s?\\/\\s?(?:hr|hour|yr|year|mo|month)\\b)?';
  var SEP = '(?:\\s|\\u00a0|-)';
  E.FIG = new RegExp('(?:' + MON + ')|\\b(?:' + R + ')(?:\\s?(?:%|percent\\b)|' + SEP + '(?:hours?|hrs?|months?)\\b)', 'gi');
  E.LEAD = new RegExp('^(?:(?:about|roughly|up to|under|over|more than|from|~)\\s?)?(?:(?:' + MON + ')|(?:' + R + ')(?:\\s?(?:%|percent\\b)|' +
    SEP + '(?:hours?|hrs?|months?|minutes?|min|weeks?|years?|days?|knots|kt|nm|lb|ft)\\b))', 'i');
  /* the items of a readout strip: 3-8 short lines, each led by a figure, no blocks inside */
  E.roItem = function (it) {
    if (it.querySelector('p,div,ul,ol,table,img,h1,h2,h3,h4,h5,h6,figure,blockquote')) return null;
    var t = E.text(it);
    if (!t || t.length > 200) return null;
    var m = E.LEAD.exec(t);
    if (!m || m[0].length > 32) return null;
    var first = null;
    for (var n = it.firstChild; n; n = n.nextSibling) { if (!E.blank(n)) { first = n; break; } }
    if (!first) return null;
    if (first.nodeType === 1 && /^(STRONG|B)$/.test(first.tagName) && E.text(first).length <= 40 && E.LEAD.test(E.text(first))) return { el: first };
    if (first.nodeType === 3) { var mm = E.LEAD.exec(first.data.replace(/^\s+/, '')); if (mm) return { txt: first, m: mm[0] }; }
    return null;
  };
  E.roList = function (items) {
    if (items.length < 3 || items.length > 8) return false;
    for (var i = 0; i < items.length; i++) if (!E.roItem(items[i])) return false;
    return true;
  };
  /* run enhancers on a box directly (tests, content added later); each one is idempotent */
  E.run = function (box, names) {
    (names || ['faq', 'steps', 'tables', 'stats']).forEach(function (n) {
      if (typeof E['do_' + n] === 'function') {
        try { E['do_' + n](box); } catch (e) { if (window.console) console.warn('[yk enh] ' + n, e); }
      }
    });
  };
})();

/* --- 40-enh-faq.js --- */
/* Enhancer "faq": question headings (h3/h4 ending in "?"), <p><strong>Question?</strong></p> and
   <p><strong>Question?</strong><br>Answer</p> followed by their answers become an accordion (APG pattern:
   heading > button[aria-expanded] + panel). Runs of 2 or more questions only. Every answer node is moved, never
   copied, into its panel; closed panels use hidden="until-found" (find-in-page and #links still reach them).
   Without JS nothing changes. FAQ JSON-LD (<script>) is never moved: it ends a run. */
(function () {
  'use strict';
  var E = window.YK_enh, YK = window.YK;
  if (!E || E.do_faq) return;
  var QMAX = 220, AMAX = 2600, BMAX = 12;
  var STOPTAG = /^(HR|SCRIPT|STYLE|TEMPLATE|NOSCRIPT|IFRAME|FORM|SECTION|ASIDE|NAV|HEADER|FOOTER|DETAILS|DIALOG|MAIN|ARTICLE)$/;

  function endsQ(t) { return /\?["'”’)]*$/.test(t); }
  function active(el) { return !!el.querySelector('a,button,input,select,textarea,iframe,img'); }

  function qkind(el) {
    var tag = el.tagName, t;
    if (tag === 'H3' || tag === 'H4') {
      t = E.text(el);
      return (t.length >= 6 && t.length <= QMAX && endsQ(t) && !active(el)) ? { k: 'h', lv: +tag.charAt(1), el: el } : null;
    }
    if (tag !== 'P') return null;
    var kids = [].filter.call(el.childNodes, function (n) { return !E.blank(n); });
    var s = kids[0];
    if (!s || s.nodeType !== 1 || !/^(STRONG|B)$/.test(s.tagName)) return null;
    t = E.text(s);
    if (t.length < 6 || t.length > QMAX || !endsQ(t) || active(s)) return null;
    if (kids.length === 1) return { k: 'p', el: el, s: s };
    var br = kids[1].nodeType === 1 && kids[1].tagName === 'BR' ? kids[1] : null;
    if (br && kids.length === 2) return { k: 'p', el: el, s: s };
    return { k: 'pb', el: el, s: s, br: br };
  }

  function stop(n, q) {
    if (qkind(n)) return true;
    var tag = n.tagName;
    if (/^H[1-6]$/.test(tag)) return q.k !== 'h' || +tag.charAt(1) <= q.lv;
    if (STOPTAG.test(tag)) return true;
    if (n.matches(E.SKIP) || n.hasAttribute('data-yk-e') || n.querySelector('[data-yk],.yk,[data-yfla-mod],form,iframe,script')) return true;
    return E.btnOnly(n);
  }

  function answer(q) {
    var nodes = [], len = 0, blocks = 0, n = q.el.nextSibling;
    if (q.k === 'pb') { nodes.push(q.el); len = E.text(q.el).length - E.text(q.s).length; blocks = 1; }
    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1) { if (stop(n, q)) break; blocks++; len += E.text(n).length; }
      else if (n.nodeType === 3) len += E.text(n).length;
      nodes.push(n);
    }
    while (nodes.length && E.blank(nodes[nodes.length - 1])) nodes.pop();
    var real = nodes.filter(function (x) { return !E.blank(x); });
    if (!real.length || len < 2 || len > AMAX || blocks > BMAX) return null;
    return { nodes: nodes, next: n };
  }

  function same(a, b) { return a.k === 'h' ? (b.k === 'h' && a.lv === b.lv) : b.k !== 'h'; }

  function level(el) {
    for (var n = el; n && !(n.hasAttribute && n.hasAttribute('data-yk-enhance')); n = n.parentElement) {
      for (var s = n.previousElementSibling; s; s = s.previousElementSibling) {
        if (/^H[1-6]$/.test(s.tagName)) return Math.min(6, +s.tagName.charAt(1) + 1);
      }
    }
    return 3;
  }

  function set(item, open) {
    var b = item.querySelector('.yk-e-faq__btn'), p = item.querySelector('.yk-e-faq__a');
    if (!b || !p) return;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-open', open);
    E.hide(p, !open);
  }

  function sync(wrap) {
    var all = wrap.querySelector('.yk-e-faq__all');
    if (!all) return;
    var items = wrap.querySelectorAll('.yk-e-faq__item'), open = wrap.querySelectorAll('.yk-e-faq__item.is-open');
    var every = items.length === open.length;
    all.textContent = every ? 'Collapse All' : 'Expand All';
    all.setAttribute('aria-pressed', every ? 'true' : 'false');
  }

  function wire(wrap) {
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('.yk-e-faq__btn, .yk-e-faq__all');
      if (!b || !wrap.contains(b)) return;
      if (b.classList.contains('yk-e-faq__all')) {
        var every = b.getAttribute('aria-pressed') === 'true';
        [].forEach.call(wrap.querySelectorAll('.yk-e-faq__item'), function (it) { set(it, !every); });
      } else {
        var it = b.closest('.yk-e-faq__item');
        set(it, b.getAttribute('aria-expanded') !== 'true');
        YK.track('faq', E.text(b).slice(0, 60));
      }
      sync(wrap);
    });
    wrap.addEventListener('keydown', function (e) {
      var b = e.target.closest && e.target.closest('.yk-e-faq__btn');
      if (!b) return;
      var bs = [].slice.call(wrap.querySelectorAll('.yk-e-faq__btn')), i = bs.indexOf(b), j = -1;
      if (e.key === 'ArrowDown') j = (i + 1) % bs.length;
      else if (e.key === 'ArrowUp') j = (i - 1 + bs.length) % bs.length;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = bs.length - 1;
      if (j < 0) return;
      e.preventDefault(); bs[j].focus();
    });
    [].forEach.call(wrap.querySelectorAll('.yk-e-faq__a'), function (p) {
      p.addEventListener('beforematch', function () { var it = p.closest('.yk-e-faq__item'); set(it, true); sync(wrap); });
    });
  }

  function convert(run) {
    var first = run[0], parent = first.el.parentNode, lv = String(level(first.el));
    var wrap = E.el('div', 'yk-e-faq', { 'data-yk-e': 'faq' });
    parent.insertBefore(wrap, first.el);
    if (run.length >= 4) {
      var bar = E.ui(E.el('div', 'yk-e-faq__bar'));
      bar.appendChild(E.el('button', 'yk-e-faq__all', { type: 'button', 'aria-pressed': 'false' }, 'Expand All'));
      wrap.appendChild(bar);
    }
    run.forEach(function (q, i) {
      var item = E.el('div', 'yk-e-faq__item'), bid = YK.uid('yk-e-fq'), pid = YK.uid('yk-e-fa');
      var btn = E.el('button', 'yk-e-faq__btn', { type: 'button', id: bid, 'aria-controls': pid, 'aria-expanded': 'false' });
      var lab = E.el('span', 'yk-e-faq__q'), head;
      wrap.appendChild(item);
      if (q.k === 'pb') {
        head = E.el('div', '', { role: 'heading', 'aria-level': lv });
        lab.appendChild(q.s);
        if (q.br) q.br.classList.add('yk-e-faq__br');
      } else {
        head = q.el;
        while (head.firstChild) lab.appendChild(head.firstChild);
        if (q.k === 'p') { head.setAttribute('role', 'heading'); head.setAttribute('aria-level', lv); }
      }
      head.classList.add('yk-e-faq__h');
      btn.appendChild(lab);
      btn.appendChild(E.ui(E.el('span', 'yk-e-faq__ic', { 'aria-hidden': 'true' })));
      head.appendChild(btn);
      item.appendChild(head);
      var panel = E.el('div', 'yk-e-faq__a', { id: pid });
      if (run.length <= 6) { panel.setAttribute('role', 'region'); panel.setAttribute('aria-labelledby', bid); }
      q.a.nodes.forEach(function (n) { panel.appendChild(n); });
      item.appendChild(panel);
      set(item, i === 0);
    });
    wire(wrap);
    sync(wrap);
  }

  E.do_faq = function (box) {
    if (E.bail(box)) return;
    var taken = [], runs = [], cur = null;
    [].forEach.call(box.querySelectorAll('h3,h4,p'), function (el) {
      for (var i = 0; i < taken.length; i++) if (taken[i].contains(el)) return;
      if (E.skip(el, box) || el.closest('[data-yk-e],li,table,blockquote')) return;
      var q = qkind(el);
      if (!q) return;
      var a = answer(q);
      if (!a) return;
      q.a = a;
      if (cur && cur.next === el && same(cur.run[0], q)) cur.run.push(q);
      else { cur = { run: [q] }; runs.push(cur); }
      cur.next = a.next;
      a.nodes.forEach(function (n) { if (n.nodeType === 1) taken.push(n); });
    });
    runs.forEach(function (r) { if (r.run.length >= 2) convert(r.run); });
    reveal();
  };

  /* a #link to a question or to anything inside a closed answer opens that answer */
  function reveal() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    var t = id && document.getElementById(id);
    if (!t) return;
    var it = t.closest('.yk-e-faq__item');
    if (!it || it.classList.contains('is-open')) return;
    set(it, true); sync(it.closest('.yk-e-faq'));
    if (t.closest('.yk-e-faq__a')) requestAnimationFrame(function () { t.scrollIntoView(); });
  }
  window.addEventListener('hashchange', reveal);

  YK.enh('faq', function (box) { E.do_faq(box); });
})();

/* --- 40-enh-gauges.js --- */
/* Element yk-gauges: design 01's course gauges. Each dial is a tab (roving tabindex, arrow keys, Home/End);
   its panel (FAA minimum with the 14 CFR citation, our packages, requirements) is server-rendered and
   toggled with [hidden]. The arcs draw in once when the element first comes into view (not with reduced motion). */
(function () {
  'use strict';
  var E = window.YK_enh, YK = window.YK;
  if (!E || E.gauges) return;
  E.gauges = 1;
  YK.reg('gauges', function (el) {
    var tabs = YK.qsa('[role=tab]', el), panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (panels[j]) panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); YK.track('gauge', YK.qs('.yk-gauges__n', t).textContent); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = -1;
        if (k === 'ArrowRight' || k === 'ArrowDown') n = (i + 1) % tabs.length;
        else if (k === 'ArrowLeft' || k === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        if (n < 0) return;
        e.preventDefault(); select(n, true);
      });
    });
    if (YK.reduced() || !('IntersectionObserver' in window)) return;
    var arcs = YK.qsa('.yk-gauges__arc, .yk-gauges__arc2', el);
    var r0 = el.getBoundingClientRect();
    if (r0.top < window.innerHeight && r0.bottom > 0) return; /* already on screen: no animation, no flash */
    arcs.forEach(function (a) { a.style.strokeDashoffset = a.getAttribute('data-len'); });
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      requestAnimationFrame(function () { arcs.forEach(function (a) { a.style.strokeDashoffset = '0'; }); });
    }, { threshold: 0.25 });
    io.observe(el);
  });
})();

/* --- 40-enh-stats.js --- */
/* Enhancer "stats": (1) a run of 3-8 short lines that each lead with a figure ("$229: the 60-minute flight",
   "20 hours of flight training ...") in a <ul>/<ol>, or as consecutive <p>s, becomes a readout strip: the
   lead figure becomes the mono value, the rest the label (text nodes are split and wrapped, never re-typed);
   (2) money, hour, percent and month figures in the copy are wrapped in <span class="yk-e-num"> (mono,
   tabular). Headings, buttons, links styled as buttons, table header cells and components are left alone. */
(function () {
  'use strict';
  var E = window.YK_enh, YK = window.YK;
  if (!E || E.do_stats) return;
  var NO = 'h1,h2,h3,h4,h5,h6,th,caption,code,pre,kbd,samp,sup,sub,a.btn,a[class*="btn"],.btn,.yk-e-num,.yk-e-ro__v,.yk-e-tnum,.yk-e-steps__tag,.yk-e-faq__h';

  function item(it) {
    var r = E.roItem(it);
    if (!r) return;
    it.classList.add('yk-e-ro__i');
    var v = E.el('span', 'yk-e-ro__v'), rest;
    if (r.el) {
      it.insertBefore(v, r.el); v.appendChild(r.el); rest = v.nextSibling;
    } else {
      var t = r.txt, lead = /^\s*/.exec(t.data)[0].length;
      if (lead) t = t.splitText(lead);
      rest = t.splitText(r.m.length);
      it.insertBefore(v, t); v.appendChild(t);
    }
    /* a separator right after the figure (":" "," "-") stays visible, muted, with the value */
    var sm = rest && rest.nodeType === 3 ? /^\s*[:,–—-]/.exec(rest.data) : null;
    if (sm) {
      var tail = rest.splitText(sm[0].length), sep = E.el('span', 'yk-e-ro__sep');
      v.appendChild(sep); sep.appendChild(rest); rest = tail;
    }
    var after = rest;
    var k = E.el('span', 'yk-e-ro__k');
    while (after) { var nx = after.nextSibling; k.appendChild(after); after = nx; }
    if (E.text(k)) it.appendChild(k);
  }

  function strips(box) {
    [].forEach.call(box.querySelectorAll('ul,ol'), function (l) {
      if (E.skip(l, box) || l.closest('[data-yk-e],li,table') || l.classList.contains('yk-e-ro')) return;
      var lis = [].filter.call(l.children, function (c) { return c.tagName === 'LI'; });
      if (lis.length !== l.children.length || !E.roList(lis)) return;
      l.classList.add('yk-e-ro'); l.setAttribute('data-yk-e', 'ro');
      lis.forEach(item);
    });
    /* consecutive <p> siblings */
    var seen = [];
    [].forEach.call(box.querySelectorAll('p'), function (p) {
      if (seen.indexOf(p) >= 0 || E.skip(p, box) || p.closest('[data-yk-e],li,table') || !E.roItem(p)) return;
      var run = [p], n = p.nextElementSibling;
      while (n && n.tagName === 'P' && E.roItem(n)) { run.push(n); n = n.nextElementSibling; }
      seen = seen.concat(run);
      if (!E.roList(run)) return;
      var wrap = E.el('div', 'yk-e-ro', { 'data-yk-e': 'ro' });
      p.parentNode.insertBefore(wrap, p);
      run.forEach(function (x) { wrap.appendChild(x); item(x); });
    });
  }

  function nums(box) {
    var w = document.createTreeWalker(box, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeType === 1) return (n.matches(E.SKIP) || n.matches(NO)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_SKIP;
        return /\d/.test(n.data) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) {
      if (E.skip(t.parentNode, box) && t.parentNode !== box) return;
      var re = new RegExp(E.FIG.source, 'gi'), m, hits = [];
      while ((m = re.exec(t.data))) { if (m[0]) hits.push([m.index, m[0].length]); else re.lastIndex++; }
      for (var i = hits.length - 1; i >= 0; i--) {
        var mid = t.splitText(hits[i][0]); mid.splitText(hits[i][1]);
        var s = E.el('span', 'yk-e-num');
        t.parentNode.insertBefore(s, mid); s.appendChild(mid);
      }
    });
  }

  E.do_stats = function (box) {
    if (E.bail(box)) return;
    strips(box);
    nums(box);
  };
  YK.enh('stats', function (box) { E.do_stats(box); });
})();

/* --- 40-enh-steps.js --- */
/* Enhancer "steps" + element yk-scrubber.
   Enhancer, list mode: an <ol> of 3-12 items becomes the design's lesson scrubber: a control row (counter,
   range, prev/next) above the list; every item stays visible, the current one is highlighted. Item click,
   range and buttons move it. Lists that are "number + label" readouts are left to the stats enhancer.
   Enhancer, run mode: 3+ headings "Step 1", "Step 2"... of one level become a step run: the headings and
   their sections are wrapped in place, a sticky rail (prev, counter, range, next) jumps between them and
   follows the reader (scroll-spy). Nothing is hidden or reordered; "Step N" gets a mono tag (text kept).
   Element yk-scrubber: the homepage "How Training Works" scrubber (range + step list + photo crossfade). */
(function () {
  'use strict';
  var E = window.YK_enh, YK = window.YK;
  if (!E || E.do_steps) return;
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function controls(n, label) {
    var bar = E.ui(E.el('div', 'yk-e-steps__bar'));
    var id = YK.uid('yk-e-sr');
    bar.innerHTML =
      '<button type="button" class="yk-e-steps__nav" data-d="-1" aria-label="Previous Step">' + E.chev(-1) + '</button>' +
      '<span class="yk-e-steps__ctr" aria-hidden="true"><span class="yk-e-steps__k">Step</span> <b>01</b> / ' + pad(n) + '</span>' +
      '<label class="yk-e-sr" for="' + id + '">' + label + '</label>' +
      '<input class="yk-e-steps__range" type="range" id="' + id + '" min="1" max="' + n + '" value="1" step="1">' +
      '<button type="button" class="yk-e-steps__nav" data-d="1" aria-label="Next Step">' + E.chev(1) + '</button>';
    return bar;
  }

  function paint(bar, i, n) {
    var r = bar.querySelector('input'), b = bar.querySelector('.yk-e-steps__ctr b'), nav = bar.querySelectorAll('.yk-e-steps__nav');
    r.value = i + 1;
    r.setAttribute('aria-valuetext', 'Step ' + (i + 1) + ' Of ' + n);
    r.style.setProperty('--yk-e-fill', (n > 1 ? i / (n - 1) * 100 : 0) + '%');
    b.textContent = pad(i + 1);
    nav[0].disabled = i === 0; nav[1].disabled = i === n - 1;
  }

  /* ---------------- list mode */
  function listMode(ol, lis) {
    var wrap = E.el('div', 'yk-e-steps', { 'data-yk-e': 'steps' }), n = lis.length, cur = 0;
    ol.parentNode.insertBefore(wrap, ol);
    var bar = controls(n, 'Scrub Through The Steps');
    wrap.appendChild(bar);
    wrap.appendChild(ol);
    ol.classList.add('yk-e-steps__list');
    var start = parseInt(ol.getAttribute('start'), 10);
    if (start > 1) ol.style.setProperty('--yk-e-start', start - 1);
    lis.forEach(function (li) { li.classList.add('yk-e-steps__item'); });
    function go(i) {
      cur = YK.clamp(i, 0, n - 1);
      lis.forEach(function (li, j) {
        li.classList.toggle('is-on', j === cur);
        if (j === cur) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
      });
      paint(bar, cur, n);
    }
    bar.addEventListener('click', function (e) { var b = e.target.closest('.yk-e-steps__nav'); if (b) go(cur + (+b.getAttribute('data-d'))); });
    bar.querySelector('input').addEventListener('input', function (e) { go(+e.target.value - 1); });
    ol.addEventListener('click', function (e) {
      if (e.target.closest('a,button,input,select,textarea,summary,label')) return;
      var li = e.target.closest('.yk-e-steps__item');
      if (li && li.parentNode === ol) go(lis.indexOf(li));
    });
    go(0);
  }

  /* ---------------- run mode ("Step 1", "Step 2" ... headings) */
  var STEP = /^\s*Step\s+(\d+)\b/i;
  function tag(h) {
    for (var t = h.firstChild; t; t = t.nextSibling) {
      if (t.nodeType !== 3) { if (E.blank(t)) continue; break; }
      var m = /^(\s*)(Step\s+\d+)/i.exec(t.data);
      if (!m) break;
      if (m[1]) t = t.splitText(m[1].length);
      t.splitText(m[2].length);
      var s = E.el('span', 'yk-e-steps__tag');
      h.insertBefore(s, t); s.appendChild(t);
      return;
    }
  }

  function runMode(hs) {
    var lv = +hs[0].tagName.charAt(1), last = hs[hs.length - 1], parent = hs[0].parentNode;
    var wrap = E.el('div', 'yk-e-steps yk-e-steps--run', { 'data-yk-e': 'steps' });
    var end = last.nextSibling;
    for (; end; end = end.nextSibling) {
      if (end.nodeType !== 1) continue;
      if (/^H[1-6]$/.test(end.tagName) && +end.tagName.charAt(1) <= lv) break;
      if (/^(SCRIPT|STYLE|TEMPLATE)$/.test(end.tagName)) break;
    }
    parent.insertBefore(wrap, hs[0]);
    var rail = controls(hs.length, 'Jump To A Step');
    rail.classList.add('yk-e-steps__rail');
    wrap.appendChild(rail);
    while (wrap.nextSibling && wrap.nextSibling !== end) wrap.appendChild(wrap.nextSibling);
    hs.forEach(function (h) { h.classList.add('yk-e-steps__h'); if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1'); tag(h); });
    var n = hs.length, cur = 0, lock = 0;
    /* a kit sub-nav (KB2) already follows the reader through the H2s: then the rail stays in the copy
       (not sticky) instead of stacking a second bar; if it is ever sticky with one, it parks under it */
    function sub() {
      var sn = document.querySelector('.yk-subnav'), h = 0;
      if (sn || E.has(rail.closest('[data-yk-enhance]') || document.body, 'subnav')) rail.classList.add('yk-e-steps__rail--static');
      if (sn && getComputedStyle(sn).position === 'sticky') h = sn.offsetHeight;
      rail.style.setProperty('--yk-e-sub', h + 'px');
    }
    sub(); setTimeout(sub, 1200); window.addEventListener('resize', sub, { passive: true });
    function off() {
      var head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--yk-head')) || 0;
      return head + (parseFloat(rail.style.getPropertyValue('--yk-e-sub')) || 0) + rail.offsetHeight + 34;
    }
    function go(i, how) {
      cur = YK.clamp(i, 0, n - 1);
      paint(rail, cur, n);
      lock = Date.now() + 900;
      var y = hs[cur].getBoundingClientRect().top + (YK.scrollY ? YK.scrollY() : window.pageYOffset) - off();
      var bh = how || (YK.reduced() ? 'auto' : 'smooth');
      if (YK.scrollTo) YK.scrollTo(y, bh); else window.scrollTo({ top: Math.max(0, y), behavior: bh });
      try { hs[cur].focus({ preventScroll: true }); } catch (e) { /* old browsers */ }
    }
    rail.addEventListener('click', function (e) { var b = e.target.closest('.yk-e-steps__nav'); if (b) go(cur + (+b.getAttribute('data-d'))); });
    var r = rail.querySelector('input');
    r.addEventListener('input', function () { go(+r.value - 1, 'auto'); });
    var tick = 0;
    function spy() {
      tick = 0;
      if (Date.now() < lock) return;
      var o = off() + 8, a = 0;
      for (var i = 0; i < n; i++) if (hs[i].getBoundingClientRect().top <= o) a = i;
      if (a !== cur) { cur = a; paint(rail, cur, n); }
    }
    var onS = function () { if (!tick) tick = requestAnimationFrame(spy); };
    if (YK.onScroll) YK.onScroll(onS); else window.addEventListener('scroll', onS, { passive: true });
    paint(rail, 0, n);
  }

  function runs(box) {
    var hs = [].filter.call(box.querySelectorAll('h2,h3,h4'), function (h) {
      return STEP.test(h.textContent) && !E.skip(h, box) && !h.closest('[data-yk-e],li,table');
    });
    var out = [], cur = null;
    hs.forEach(function (h) {
      var num = +STEP.exec(h.textContent)[1];
      if (cur && h.parentNode === cur.p && h.tagName === cur.t && num === cur.num + 1 && !between(cur.last, h)) {
        cur.hs.push(h); cur.num = num; cur.last = h;
      } else if (num === 1) { cur = { p: h.parentNode, t: h.tagName, num: 1, last: h, hs: [h] }; out.push(cur); }
      else cur = null;
    });
    return out.filter(function (r) { return r.hs.length >= 3; }).map(function (r) { return r.hs; });
  }
  /* a heading of the same or a higher level that is not a step ends the run */
  function between(a, b) {
    var lv = +a.tagName.charAt(1);
    for (var n = a.nextElementSibling; n && n !== b; n = n.nextElementSibling) {
      if (/^H[1-6]$/.test(n.tagName) && +n.tagName.charAt(1) <= lv) return true;
    }
    return false;
  }

  E.do_steps = function (box) {
    if (E.bail(box)) return;
    var ro = E.has(box, 'stats');
    [].forEach.call(box.querySelectorAll('ol'), function (ol) {
      if (E.skip(ol, box) || ol.closest('[data-yk-e],li,table') || ol.hasAttribute('reversed')) return;
      var lis = [].filter.call(ol.children, function (c) { return c.tagName === 'LI'; });
      if (lis.length < 3 || lis.length > 12 || lis.length !== ol.children.length) return;
      if (lis.some(function (li) { return !E.text(li); }) || E.text(ol).length > 6000) return;
      if (ro && E.roList(lis)) return;
      listMode(ol, lis);
    });
    runs(box).forEach(runMode);
  };
  YK.enh('steps', function (box) { E.do_steps(box); });

  /* ---------------- element: yk-scrubber */
  YK.reg('scrubber', function (el) {
    var items = YK.qsa('.yk-scrubber__item', el), imgs = YK.qsa('.yk-scrubber__img', el);
    var r = YK.qs('input[type=range]', el), ctr = YK.qs('[data-yk-ctr]', el);
    var prev = YK.qs('[data-yk-prev]', el), next = YK.qs('[data-yk-next]', el);
    var titles = (r.getAttribute('data-yk-titles') || '').split('|'), n = items.length, cur = 0;
    function go(i, track) {
      cur = YK.clamp(i, 0, n - 1);
      items.forEach(function (it, j) {
        it.classList.toggle('is-on', j === cur);
        var b = it.querySelector('.yk-scrubber__btn'); if (b) b.setAttribute('aria-pressed', j === cur ? 'true' : 'false');
      });
      imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === cur); if (j === cur) im.loading = 'eager'; });
      r.value = cur + 1; YK.fill(r);
      r.setAttribute('aria-valuetext', 'Step ' + (cur + 1) + ' Of ' + n + (titles[cur] ? ': ' + titles[cur] : ''));
      if (ctr) ctr.textContent = (cur + 1) + ' / ' + n;
      prev.disabled = cur === 0; next.disabled = cur === n - 1;
      if (track) YK.track('scrubber', titles[cur] || String(cur + 1));
    }
    el.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      if (e.target.closest('[data-yk-prev]')) return go(cur - 1, 1);
      if (e.target.closest('[data-yk-next]')) return go(cur + 1, 1);
      var it = e.target.closest('.yk-scrubber__item');
      if (it) go(items.indexOf(it), 1);
    });
    r.addEventListener('input', function () { go(+r.value - 1); });
    r.addEventListener('change', function () { go(+r.value - 1, 1); });
    /* warm the next photos once the element is near, so the crossfade never shows an empty frame */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        imgs.forEach(function (im) { im.loading = 'eager'; });
        io.disconnect();
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    }
    go(0);
  });
})();

/* --- 40-enh-tables.js --- */
/* Enhancer "tables" + element yk-compare.
   Enhancer: every body <table> (not a [data-yfla-mod] widget) gets its own overflow-x scroller (focusable
   region named by the caption), zebra rows, mono numbers in figure cells, a sticky first column on regular
   grids, and, with more than 3 columns, column toggle chips (aria-pressed) + Show Fewer / Show All. All
   columns are visible at load; hiding one is the reader's choice. Cells are never moved or re-typed.
   Element yk-compare: the homepage design's "Compare Every Package" (same chip logic, server-rendered). */
(function () {
  'use strict';
  var E = window.YK_enh, YK = window.YK;
  if (!E || E.do_tables) return;
  var NUMCELL = /^(?:[~≈<>]|about |roughly |up to |under |over |from )?\s*\$?\d[\d,.]*(?:\s?(?:%|[kKmM]\b|hrs?\b|hours?\b|min\b|minutes?\b|months?\b|weeks?\b|years?\b|days?\b|nm\b|kt\b|knots\b|lb\b|lbs\b|ft\b|\/hr\b|\/yr\b|\/mo\b|\+))*(?:\s?(?:–|—|-|to|or)\s?\$?\d[\d,.]*(?:\s?(?:%|[kKmM]\b|hrs?\b|hours?\b|min\b|minutes?\b|months?\b|weeks?\b|years?\b|days?\b|\/hr\b|\+))*)?\s*$/i;

  function cellsOf(t) { return [].map.call(t.rows, function (r) { return [].slice.call(r.cells); }); }

  /* column chips: idx = 1-based column numbers; cls = the class that hides a cell */
  E.cols = function (t, chips, all, cls, fewer) {
    var bs = [].slice.call(chips.querySelectorAll('[data-col]'));
    function apply() {
      var on = {};
      bs.forEach(function (b) { on[b.getAttribute('data-col')] = b.getAttribute('aria-pressed') === 'true'; });
      cellsOf(t).forEach(function (row) {
        row.forEach(function (c, i) { if (i > 0 && (i + 1) in on) c.classList.toggle(cls, !on[i + 1]); });
      });
      var every = bs.every(function (b) { return b.getAttribute('aria-pressed') === 'true'; });
      if (all) { all.textContent = every ? 'Show Fewer' : 'Show All'; all.setAttribute('aria-pressed', every ? 'true' : 'false'); }
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !chips.contains(b)) return;
      if (b === all) {
        var every = bs.every(function (x) { return x.getAttribute('aria-pressed') === 'true'; });
        bs.forEach(function (x) { x.setAttribute('aria-pressed', !every || fewer.indexOf(x.getAttribute('data-col')) >= 0 ? 'true' : 'false'); });
      } else {
        var onNow = b.getAttribute('aria-pressed') === 'true';
        if (onNow && bs.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; }).length === 1) return;
        b.setAttribute('aria-pressed', onNow ? 'false' : 'true');
      }
      apply();
      YK.track('columns', E.text(b).slice(0, 40));
    });
    apply();
  };

  /* scrolled-state shadow on the sticky column; --yk-e-vw keeps the caption inside the visible width */
  function shade(sc) {
    var f = function () { sc.classList.toggle('is-scrolled', sc.scrollLeft > 2); };
    var w = function () { sc.style.setProperty('--yk-e-vw', sc.clientWidth + 'px'); };
    sc.addEventListener('scroll', f, { passive: true }); f(); w();
    if ('ResizeObserver' in window) new ResizeObserver(w).observe(sc); else window.addEventListener('resize', w);
  }

  function one(t, box) {
    var rows = cellsOf(t);
    if (rows.length < 2) return;
    var wrap = E.el('div', 'yk-e-table', { 'data-yk-e': 'table' }), sc = E.el('div', 'yk-e-table__scroll', { tabindex: '0', role: 'region' });
    var cap = t.caption;
    if (cap && E.text(cap)) { if (!cap.id) cap.id = YK.uid('yk-e-cap'); sc.setAttribute('aria-labelledby', cap.id); }
    else sc.setAttribute('aria-label', 'Table');
    t.parentNode.insertBefore(wrap, t);
    wrap.appendChild(sc); sc.appendChild(t);
    t.classList.add('yk-e-t');
    var spans = !!t.querySelector('[colspan]:not([colspan="1"]),[rowspan]:not([rowspan="1"])');
    var ncol = Math.max.apply(null, rows.map(function (r) { return r.length; }));
    if (!spans) t.classList.add('yk-e-t--grid');
    if (ncol >= 4) t.classList.add('yk-e-t--wide');
    rows.forEach(function (r) { r.forEach(function (c) { if (NUMCELL.test(E.text(c))) c.classList.add('yk-e-tnum'); }); });
    shade(sc);
    if (spans || ncol <= 3) return;
    var head = t.tHead && t.tHead.rows.length ? t.tHead.rows[t.tHead.rows.length - 1] : null;
    if (!head) { var r0 = t.rows[0]; if ([].every.call(r0.cells, function (c) { return c.tagName === 'TH'; })) head = r0; }
    if (!head || head.cells.length !== ncol) return;
    var tools = E.ui(E.el('div', 'yk-e-table__tools', { role: 'group', 'aria-label': 'Table Columns' }));
    tools.appendChild(E.el('span', 'yk-e-table__lbl', { 'aria-hidden': 'true' }, 'Columns'));
    for (var i = 1; i < ncol; i++) {
      tools.appendChild(E.el('button', 'yk-e-chip', { type: 'button', 'aria-pressed': 'true', 'data-col': String(i + 1) }, E.text(head.cells[i]) || ('Column ' + (i + 1))));
    }
    var all = E.el('button', 'yk-e-chip yk-e-chip--all', { type: 'button' }, 'Show Fewer');
    tools.appendChild(all);
    wrap.insertBefore(tools, sc);
    E.cols(t, tools, all, 'yk-e-off', ['2', '3']);
  }

  E.do_tables = function (box) {
    if (E.bail(box)) return;
    [].forEach.call(box.querySelectorAll('table'), function (t) {
      if (E.skip(t, box) || t.closest('.yk-e-table') || (t.parentElement && t.parentElement.closest('table'))) return;
      one(t, box);
    });
  };
  YK.enh('tables', function (box) { E.do_tables(box); });

  /* ---------------- element: yk-compare */
  YK.reg('compare', function (el) {
    var sc = YK.qs('.yk-compare__scroll', el), t = YK.qs('table', el), chips = YK.qs('[data-yk-chips]', el);
    if (sc) shade(sc);
    if (!chips || !t) return;
    var all = YK.qs('[data-yk-all]', chips);
    E.cols(t, chips, all, 'is-off', (all.getAttribute('data-yk-all') || '').split(','));
  });
})();
